<template>
  <div v-if="loading_page"></div>
  <div v-else :id="seller.receipt_size == 1 ? 'invoice-POS' : 'invoice-POS-58'" :class="seller.receipt_size == 1 ? 'invoice-POS' : 'invoice-POS-58'">
    <center id="top" style="display: grid; align-items: center;align-content: center;justify-content: center;">
     
      <div class="info w-100">
        <div  v-if="detailList.invoice.status == 2" :class="seller.receipt_size == 1 ? 'font-16-cancel' : 'font-14-58-cancel' "> ยกเลิก </div>
      </div><!--End Info-->
      <div class="logo text-center" >
        <img v-if="$route.query.vat_status != 2" :src="img_arin" alt="" style="max-width: 150px;margin-left: 120px;">
      </div>
      <div class="info w-100">
        <div  v-if="$route.query.vat_status != 2" :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' ">{{ seller.status_main_store == 1 ? 'บริษัท ฟาร์มาแคร์ พลัส จำกัด' : seller.store_name }}</div>
        <div  v-if="$route.query.vat_status != 2" :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' ">{{ seller.address }} {{ seller.address_list }}</div>
        <div  v-if="$route.query.vat_status != 2" :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' ">{{ seller.owner_name }} เลขที่สาขา : {{ seller.store_code }}</div>
        <div  v-if="$route.query.vat_status != 2" :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' ">TAX#{{ seller.store_personal_id }} (VAT Includ)</div>
        <div  v-if="$route.query.vat_status != 2" :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' ">ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ</div>
        <div  v-if="$route.query.vat_status != 2" :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' ">POS {{ seller.posid }}</div>
        <div  v-if="$route.query.vat_status != 2" :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' ">เบอร์โทร {{ seller.tel }}</div>
      </div><!--End Info-->
      <h2 v-if="$route.query.vat_status == 2">ใบเสร็จรับเงิน</h2>
    </center>
    <!--End InvoiceTop-->

    <v-row style="margin-top: 10px !important;">
      <v-col cols="6">
        <div :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' ">{{ detailList.invoice.invoice_code }}</div>
      </v-col>
      <v-col cols="6">
        <div :class="seller.receipt_size == 1 ? 'font-13 text-right' : 'font-13-58 text-right' ">{{ detailList.invoice.created_at != null ?
          `${detailList.invoice.created_at.split('-')[2].split(' ')[0]}/${detailList.invoice.created_at.split('-')[1]}/${detailList.invoice.created_at.split('-')[0]} @
                  ${ detailList.invoice.created_at.split('-')[2].split(' ')[1] }` : '-'}}</div>
      </v-col>

    </v-row>
    <div class="color-gray" :class="seller.receipt_size == 1 ? 'font-11' : 'font-11-58' "> - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -</div>
    <div id="bot">
      <div id="table">
        <table>
          <tr class="tabletitle">
            <td class="item " :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' " style="width:10px !important;">
              <h2>Item</h2>
            </td>
            <td class=" text-center" :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' ">
              <h2>ราคา</h2>
            </td>
            <td class=" text-center" :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' ">
              <h2>จำนวน</h2>
            </td>
            <td class=" text-center" :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' ">
              <h2>รวม</h2>
            </td>
          </tr>

          <tr v-for="( item, index ) in  detailList.invoice_list " :key=" index " class="service">
            <td class="tableitem" :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' ">
              <p class=" pr-2 mt-5" :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' ">{{ item.product_name }}</p>
              <p class=" pr-2 mt-5 text-center" :class="seller.receipt_size == 1 ? 'font-10' : 'font-10-58' " v-if=" item.discount > 0 ">ส่วนลด
                {{item.product_name}}</p>
            </td>
            <td class="tableitem text-right va-top" :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' ">
              <p class="mt-5" :class="seller.receipt_size == 1 ? 'font-12' : 'font-12-58' ">{{ formatPrice(item.price) }}</p>
              <br v-if=" item.discount > 0 ">
            </td>
            <td class="tableitem text-center va-top" :class="seller.receipt_size == 1 ? 'font-12' : 'font-12-58' ">
              <p class=" mt-5" :class="seller.receipt_size == 1 ? 'font-12' : 'font-12-58' " v-if=" item.product_code == null ">-{{ item.qty }} {{ item.unit_name }}</p>
              <p class=" mt-5" :class="seller.receipt_size == 1 ? 'font-12' : 'font-12-58' " v-else>{{ item.qty }} {{ item.unit_name }}</p>
              <br v-if=" item.discount > 0 ">
            </td>
            <td class="tableitem text-right va-top" :class="seller.receipt_size == 1 ? 'font-12' : 'font-12-58' ">
              <p class=" mt-5" :class="seller.receipt_size == 1 ? 'font-12' : 'font-12-58' " v-if=" item.product_code == null ">-{{
                formatPrice(parseFloat(item.total)+parseFloat(item.discount)) }}</p>
              <p class=" mt-5" :class="seller.receipt_size == 1 ? 'font-12' : 'font-12-58' " v-else>{{ formatPrice((parseFloat(item.total) || 0) + (parseFloat(item.discount) || 0)) }}</p>
              <p class=" mt-5" :class="seller.receipt_size == 1 ? 'font-12' : 'font-12-58' " v-if=" item.discount > 0 ">-{{ formatPrice(item.discount) }}</p>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <div class="color-gray" :class="seller.receipt_size == 1 ? 'font-11' : 'font-11-58' "> - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
              </div>
            </td>
          </tr>



          <tr class="tabletitle">
            <td>
              <p class="mt-5" :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' ">รวมเงิน</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5" :class="seller.receipt_size == 1 ? 'font-12' : 'font-12-58' ">{{ formatPrice(total_price) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 " :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' ">ส่วนลดท้ายบิล</p>
            </td>
            <td></td>
            <td>
              <p class="mt-5 " :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' "></p>
            </td>
            <td class="text-right">
              <p class="mt-5" :class="seller.receipt_size == 1 ? 'font-12' : 'font-12-58' ">{{ formatPrice(detailList.invoice.discount) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5" :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' ">มูลค่าสินค้า</p>
            </td>
            <td></td>
            <td> <p class="mt-5" :class="seller.receipt_size == 1 ? 'font-12' : 'font-12-58' ">{{total_qty}} ชิ้น</p></td>
            <td class="text-right">
              <p class="mt-5" :class="seller.receipt_size == 1 ? 'font-12' : 'font-12-58' ">{{ formatPrice(parseFloat(detailList.invoice.cost)) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 " :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' ">ภาษีมูลค่าเพิ่ม 7%</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 " :class="seller.receipt_size == 1 ? 'font-12' : 'font-12-58' ">{{ formatPrice(detailList.invoice.vat) }}</p>
            </td>
          </tr>
          <tr class="tabletitle"
            v-if=" detailList.invoice.credit_charge_status == 1 && detailList.invoice.pay_type.find(o => o === 3) ">
            <td>
              <p class="mt-5 " :class="seller.receipt_size == 1 ? 'font-12' : 'font-12-58' ">เครดิตชาร์ต {{parseFloat(detailList.invoice.credit_charge)}}% </p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 " :class="seller.receipt_size == 1 ? 'font-12' : 'font-12-58' ">{{ formatPrice((parseFloat(detailList.invoice.credit_uncharge) *
                parseFloat(detailList.invoice.credit_charge / 100))) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 " :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' ">ยอดเงินสุทธิ </p>
            </td>
            <td></td>
            <td></td>
            <td v-if=" detailList.invoice.credit_charge_status == 1 && detailList.invoice.pay_type.find(o => o === 3) "
              class="text-right">
              <p class="mt-5 " :class="seller.receipt_size == 1 ? 'font-12' : 'font-12-58' ">{{ formatPrice(parseFloat(detailList.invoice.total) -
                parseFloat(detailList.invoice.use_point == null || detailList.invoice.use_point == '' ? 0 : detailList.invoice.use_point)) }}</p>
            </td>
            <td v-else class="text-right">
              <p class="mt-5" :class="seller.receipt_size == 1 ? 'font-12' : 'font-12-58' ">{{ formatPrice(parseFloat(parseFloat(detailList.invoice.total) -
                parseFloat(detailList.invoice.use_point == null || detailList.invoice.use_point == '' ? 0 : detailList.invoice.use_point))) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 " :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' ">รับเงิน </p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 " :class="seller.receipt_size == 1 ? 'font-12' : 'font-12-58' ">{{
                formatPrice(parseFloat(detailList.invoice.cash)+parseFloat(detailList.invoice.payment)+parseFloat(detailList.invoice.credit)+parseFloat(detailList.invoice.etc_payment)+parseFloat(detailList.invoice.qrcode_pay))
                }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 " :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' ">เงินทอน </p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p v-if=" detailList.invoice.credit_charge_status == 1 && detailList.invoice.pay_type.find(o => o === 3) " class="mt-5 font-12">{{ formatPrice(parseFloat(0)) }}</p>
              <p v-else class="mt-5 " :class="seller.receipt_size == 1 ? 'font-12' : 'font-12-58' ">{{ formatPrice(parseFloat(detailList.invoice.change)) }}</p>
            </td>
          </tr>

          <tr>
            <td colspan="4">
              <div class="color-gray" :class="seller.receipt_size == 1 ? 'font-11' : 'font-11-58' "> - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
              </div>
            </td>
          </tr>

          <tr>
            <td colspan="4">
              <div :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' "> ข้อมูลสมาชิก {{detailList.invoice.member_name}} </div>
            </td>
          </tr>
          <br>
          <tr>
            <td class="item"></td>
            <td>
              <p class=" text-center mt-5" :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' ">ได้รับ</p>
            </td>
            <td>
              <p class=" text-center mt-5" :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' ">ใช้ไป</p>
            </td>
            <td>
              <p class=" text-center mt-5" :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' ">คงเหลือ</p>
            </td>
          </tr>

          <tr>
            <td>
              <p class=" mt-5" :class="seller.receipt_size == 1 ? 'font-13' : 'font-13-58' ">แต้มสมาชิก</p>
            </td>
            <td>
              <p class=" text-center mt-5" :class="seller.receipt_size == 1 ? 'font-12' : 'font-12-58' ">+{{detailList.invoice.member_name == null ? formatPrice(0).split('.')[0] :
                formatPrice(detailList.invoice.point).split('.')[0]}}</p>
            </td>
            <td>
              <p class=" text-center mt-5" :class="seller.receipt_size == 1 ? 'font-12' : 'font-12-58' ">{{formatPrice(detailList.invoice.use_point).split('.')[0]}}</p>
            </td>
            <td>
              <p class=" text-center mt-5" :class="seller.receipt_size == 1 ? 'font-12' : 'font-12-58' ">{{formatPrice(detailList.invoice.point_remain).split('.')[0]}}</p>
            </td>
          </tr>

          <tr>
            <td colspan="4">
              <div class="color-gray-mid mt-4 " :class="seller.receipt_size == 1 ? 'font-10' : 'font-10-58' "> ** ยอดใช้ไปและยอดคงเหลือ ไม่รวมยอดสะสมครั้งนี้ ** </div>
            </td>
          </tr>

        </table>
      </div><!--End Table-->

      <div id="legalcopy" class="text-center">
        <p :class="seller.receipt_size == 1 ? 'font-14' : 'font-14-58' "> {{this.seller.invoice_note}} </p>
      </div>
    </div><!--End InvoiceBot-->
  </div><!--End Invoice-->
</template>

<script>
import img_arin from "@/assets/arin_assets/pharmacare-black.png";
import { HTTP_ARIN } from "@/axios_arin";
import { formatPrice } from "@/js/handler";
export default {
  data() {
    return {
      img_arin: img_arin,
      items: [
        { name: "tab.CARATEN 12.5 MG. ...", sale: "ส่วนลด NODOGLE SPRAY ", quantity: 5, subTotal: 375, slae_cost: 80 },
        // { name: "eent.NODOGLE SPRAY   ...",sale: null, quantity: 3, subTotal: 225 , slae_cost: 0},
        // { name: "ยาดม IZE JELLI BALM 7  ...",sale: null, quantity: 5, subTotal: 375 , slae_cost: 0},
        // { name: "cr.DELANIN CREAM 5G ...",sale: null, quantity: 20, subTotal: 1500 , slae_cost: 0},

      ],
      value: 295,
      sale_sum: 20,
      tax: 19.25,
      credit: 8.83,
      total: 303.08,
      cash: 310.00,
      change: 6.92,
      detailList: [],
      total_qty: 0,
      total_price: 0,
      seller: {},
      loading_page: true,
      vowelCharacters: "aeiouAEIOUะัาำิีึื็ุู่้๊๋์ํๆ"
    };
  },
  methods: {
    truncateString(product_name) {
      var maxLength = 15;
      var truncatedString = '';
      var characterCount = 0;

      for (var i = 0; i < product_name.length; i++) {
        var character = product_name[i];
        truncatedString += character;

        if (this.vowelCharacters.indexOf(character) === -1) {
          characterCount++;
        }

        if (characterCount >= maxLength) {
          break;
        }
      }

      if (product_name.length > maxLength) {
        truncatedString += "...";
      }

      product_name = truncatedString;
      return product_name
    },
    formatPrice(value) {
      return formatPrice(value);
    },
    async print() {
      if(this.seller.receipt_size == 1){
        document.getElementById("invoice-POS").innerHTML;
      }else{
        document.getElementById("invoice-POS-58").innerHTML;
      }
      // document.body.innerHTML = printContents;
      const originalContents = document.body.innerHTML;
      window.print();


      window.onafterprint = function () {
        document.body.innerHTML = originalContents;
        window.close();
      };
    },
    async getReceipt() {
      this.loading_page = true;
      let config = {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
        }
      }
      let id = this.$route.query.id
      await HTTP_ARIN.get(`/pos/invoice/detail/${id}`, config).then(async(res) => {
        if (res.data.successful === true) {
          this.detailList = res.data.data
          this.detailList.invoice_list.forEach((detail) => {
            if (detail.product_code != null) {
              this.total_qty += parseFloat(detail.qty)
              this.total_price += parseFloat(detail.total)
            } else {
              this.total_price -= parseFloat(detail.total)
            }
          })
          this.loading_page = false;
         await this.getSotre()
        }
      })
    },
    async getSotre() {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
        }
      }
      let store_id = this.$store.state.store_arin.user_data.store_id;
      await HTTP_ARIN.get('/stores/detail/' + store_id, config).then(async (res) => {
        if (res.data.successful === true) {
          this.seller = res.data.storeDetail;
        }
      })
      await this.print()
    },
  },
  mounted() {
    this.getReceipt()

  },
};
</script>

<style scoped>
.font-10 {
  font-size: 10px;
}

.font-11 {
  font-size: 11px;
}

.font-12 {
  font-size: 11.5px;
}

.font-13 {
  font-size: 11.5px;
}

.font-16-cancel {
  font-size: 32px;
}

.font-14 {
  font-size: 14px;
}

.font-10-58 {
  font-size: 9px;
}

.font-11-58 {
  font-size: 7.65px;
}

.font-12-58 {
  font-size: 10.5px;
}

.font-13-58 {
  font-size: 10.5px;
}

.font-14-58-cancel {
  font-size: 28px;
}

.font-14-58 {
  font-size: 13px;
}
#invoice-POS-58 {
  box-shadow: 0 0 1in -0.25in rgba(0, 0, 0, 0.5);
  padding: 3mm;
  margin: 0 auto;
  width: 58mm;
  background: #FFF;
}

#invoice-POS {
  box-shadow: 0 0 1in -0.25in rgba(0, 0, 0, 0.5);
  padding: 2mm;
  margin: 0 auto;
  width: 80mm;
  background: #FFF;
}

.invoice-POS-58 {
  box-shadow: 0 0 1in -0.25in rgba(0, 0, 0, 0.5);
  padding: 3mm;
  margin: 0 auto;
  width: 58mm;
  background: #FFF;
}

.invoice-POS {
  box-shadow: 0 0 1in -0.25in rgba(0, 0, 0, 0.5);
  padding: 2mm;
  margin: 0 auto;
  width: 80mm;
  background: #FFF;
}

::selection {
  background: #f31544;
  color: #FFF;
}

::moz-selection {
  background: #f31544;
  color: #FFF;
}

h1 {
  font-size: 1.5em;
  color: #000000;
}

h2 {
  font-size: 0.9em;
}

h3 {
  font-size: 1.2em;
  font-weight: 300;
  line-height: 2em;
}

p {
  font-size: 1em;
  color: #000000;
  line-height: 1.2em;
}

#top,
#mid,
#bot {
  /* Targets all id with 'col-' */
  border-bottom: 1px solid #EEE;
}

#top {
  min-height: 100px;
}

#mid {
  min-height: 80px;
}

#bot {
  min-height: 50px;
}

#top .logo {
  /*float: left;*/
  /* height: 60px; */
  width: 150px;
  /* background: url('img_arin') no-repeat; */
  background-size: 60px 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.clientlogo {
  float: left;
  height: 60px;
  width: 60px;
  background: url(http://michaeltruong.ca/images/client.jpg) no-repeat;
  background-size: 60px 60px;
  border-radius: 50px;
}

.info {
  display: block;
  /*float:left;*/
  margin-left: 0;
}

.title {
  float: right;
}

.title p {
  text-align: right;
}

table {
  width: 100%;
  border-collapse: collapse;
}

td p {
  font-size: 0.9em;
  /*padding: 5px 0 5px 15px;*/
  /*border: 1px solid #EEE*/
}

.tabletitle {
  /*padding: 5px;*/
  font-size: 0.6em;
  /* background: #EEE; */
}

.service {
  border-bottom: 0px solid #EEE;
}

.item {
  width: 40mm;
}

.item-med {
  width: 15mm;
}

.itemtext {
  font-size: 0.9em;
}

.Rate {
  font-size: 0.9em;
}

.payment {
  font-size: 1.2em;
}

#legalcopy {
  margin-top: 7mm;
  margin-bottom: 7mm;
}

.flex-center {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.pr-5 {
  padding-right: 5px;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.w-100 {
  width: 100%;
}

.color-gray {
  color: #000000;
}

.color-gray-mid {
  color: #000000;
}

.va-top {
  vertical-align: top;
}

.mt-10 {
  margin-top: 10px;
}

.mt-5 {
  margin-top: 7px;
}

.mt-4 {
  margin-top: 4px;
}</style>


